/* eslint-disable prefer-rest-params */
export const ReplaceDataLabelsWithDot = (H: any) => {
  H.wrap(H.Series.prototype, 'drawDataLabels', function (proceed: any) {
    // tslint:disable-next-line
    const series: any = this;
    if (series.options.hideLabels) {
      if (series.chart.dotsDrawn && !series.chart.isResizing) {
        return;
      }

      const selected = series.data.find(item => item.selected);
      if (selected) {
        // Draw a dot in place of the data label based on the selected cell's width and height, but not exceeding 10px radius
        const dotSizeBasedOnCellWidth = Math.min(selected.shapeArgs.width / 2 - 1, selected.shapeArgs.height / 2 - 1, 10);
        const x = selected.plotX + series.chart.plotLeft;
        const y = selected.plotY + series.chart.plotTop;

        if (series.chart?.isResizing) {
          series.chart.container?.getElementsByClassName("highcharts-data-labels-dot")?.[0]?.remove();
        }
        
        series.chart.renderer.circle(x, y, dotSizeBasedOnCellWidth).attr({
          fill: selected.dataLabels?.color,
          zIndex: 100,
          class: 'highcharts-data-labels-dot'
        }).add();
      }
    } else {
      proceed.apply(series, Array.prototype.slice.call(arguments, 1));
    }
    series.chart.dotsDrawn = true;
  });
};
